import type { IComponentController } from "angular";

import type { ILoginService, IProfileService } from "App/Modules/Auth";

export default class AboutComponentController implements IComponentController {
    public static $inject: string[] = ["mmProfileService", "mmLoginService"];

    public isLoggedIn = true;

    constructor(private readonly profileService: IProfileService, private readonly loginService: ILoginService) {}

    public $onInit(): void {
        this.loginService.isLoggedInObservable().subscribe((loggedIn) => {
            this.isLoggedIn = loggedIn;
        });

        this.profileService.profileObservable().subscribe();
    }
}
